import { render } from "./CourseRequests.vue?vue&type=template&id=f89a2636"
import script from "./CourseRequests.vue?vue&type=script&lang=js"
export * from "./CourseRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CourseRequests/CourseRequests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f89a2636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f89a2636', __exports__)) {
    api.reload('f89a2636', __exports__)
  }
  
  module.hot.accept("./CourseRequests.vue?vue&type=template&id=f89a2636", () => {
    api.rerender('f89a2636', render)
  })

}


export default __exports__